export const sourceData = {
  ...drupalSettings.find_your_path_data,
};

export const settings = {
  ...drupalSettings.find_your_path_data.settings,
};
